import { createContext, useContext } from "react";

import { ProductOptionFormModelContext, type ProductOptionFormModelContextType } from "../../_shared/context/context";

export type ProductNewOptionFormModelContextType = {
	onUpdate: () => void;
} & ProductOptionFormModelContextType;

export const ProductNewOptionFormModelContext = createContext<ProductNewOptionFormModelContextType | null>(null);

export const ProductNewOptionFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductNewOptionFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductNewOptionFormModelContext.Provider value={value}>
			<ProductOptionFormModelContext.Provider value={value}>{children}</ProductOptionFormModelContext.Provider>
		</ProductNewOptionFormModelContext.Provider>
	);
};

export const useProductNewOptionFormModelContext = () => {
	const context = useContext(ProductNewOptionFormModelContext);

	if (!context) {
		throw new Error(
			"useProductNewOptionFormModelContext must be used within a ProductNewOptionFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
